module.exports = __webpack_public_path__ + "img/arrival-camera.4a7bbef4.svg";